import { v4 as uuidv4 } from 'uuid';
import { login, logout } from '@/api/auth';
import { AppError } from '@/errors/appError';
// import { currencyDictionary } from '@/stores/simpleDictionary/currency';
import { globals } from '@/globals';
import { getWebSocketURL } from '@/helpers';
import { resetPageStores } from '@/helpers/resetPageStores';
import i18n from '@/plugins/i18n';
import pinia from '@/plugins/pinia';
import { resetInputHistoryState } from '@/composables/useInputHistory';
import { connectWebSocket, disconnectWebSocket } from '@/services/webSocketClient';
import { useAppStore } from '@/stores/app';
import { useAuthStore } from '@/stores/auth';
import { useMenuStore } from '@/stores/menu';
import { useUserStore } from '@/stores/user';
import { ILoginParams } from '@/types';

const AuthService = {
    async logout() {
        const menuStore = useMenuStore();
        try {
            const response = await logout();
            if (response.data.success) {
                const appStore = useAppStore();

                localStorage.removeItem('refreshTime');
                localStorage.removeItem('user');
                localStorage.removeItem('token');

                disconnectWebSocket();

                menuStore.withMenu = false;
                menuStore.userMenu = false;
                menuStore.mobileMenuDrawer = false;

                localStorage.removeItem('user');
                appStore.resetState();
                menuStore.clearRecentMenuLinks();
                resetInputHistoryState();
                appStore.uniqAppId = uuidv4();
                await globals.router.push({ name: 'login' });
            } else {
                const authStore = useAuthStore();
                authStore.errorMessage = response.data.message;
            }
        } catch (e) {
            throw new AppError(`Unable to logout, request error`, { cause: e });
        } finally {
        }
    },

    async login(params: ILoginParams) {
        const authStore = useAuthStore();

        const response = await login({
            username: params.username,
            password: params.password,
            os: params.os,
            browser: params.browser,
        });

        if (response.data.success) {
            resetPageStores(pinia);

            const userStore = useUserStore();
            const menuStore = useMenuStore();
            const sessionAuthStore = useAuthStore();
            const user = JSON.parse(response.data.user);

            userStore.token = response.data.token;
            userStore.id = user.id;
            userStore.login = user.login;
            userStore.type = user.type;
            userStore.owner_id = user.owner_id ?? null;
            // userStore.currency.id = user.currency;
            // userStore.currency.symbol = currencyDictionary.itemById(user.currency).symbol;
            userStore.timeZone = user.timeZone;

            menuStore.$hydrate();
            resetInputHistoryState();

            sessionAuthStore.errorMessage = '';
            // sessionAuthStore.isShowSendVerifyEmailLink = false;
            menuStore.userMenu = false;
            menuStore.mobileMenuDrawer = false;
            menuStore.withMenu = true;
            connectWebSocket(getWebSocketURL(response.data.token));
        } else {
            localStorage.removeItem('user');
            localStorage.removeItem('token');

            const t = i18n.global.t;
            authStore.errorMessage = t(response.data.message);
        }
        return response;
    },
};

export default AuthService;
